import Actions from '../actions/actions';
import { setBusy, setUnBusy } from './common/commonReducers';
import { SearchAttributes } from '../interfaces/leads';
import VoyagerCRUDActions from '../actions/VoyagerCRUDActions';
import {
  VoyagerAttributes,
  VoyagerLeadsState,
} from '../interfaces/voyagerLeads';
import _ from 'lodash';

const initialState: VoyagerLeadsState = {
  busy: false,
  attributes: [],
  contacts: {},
};

const retrievedAll = (
  state: VoyagerLeadsState,
  action: { entities: SearchAttributes },
) => {
  const { entities } = action;
  return {
    ...state,
    busy: false,
    attributes: entities,
  };
};

export default function voyagerLeads(state = initialState, action: any) {
  switch (action.type) {
    case VoyagerCRUDActions.busyAction:
      return setBusy(state);
    case VoyagerCRUDActions.unbusyAction:
      return setUnBusy(state);
    case VoyagerCRUDActions.retrievedAllAction:
      return retrievedAll(state, {
        entities: action.entities?.map((entity: VoyagerAttributes) => ({
          attribute: entity.attribute,
          items: entity.items,
        })),
      });
    case VoyagerCRUDActions.retrieveLeadsBySearchAttributes: {
      return {
        ...state,
        contacts: action.contacts,
        busy: false,
      };
    }
    case VoyagerCRUDActions.resetLeadsAction: {
      return {
        ...state,
        contacts: {},
        busy: false,
      };
    }
    case Actions.RESET:
      return initialState;
    case Actions.UNBUSY:
      return { ...state, busy: false };
    default:
      return state;
  }
}
